"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var email_list_html_1 = __importDefault(require("./email-list.html"));
require("./email-list.less");
(function (app) {
    'use strict';
    app.directive('prEmailList', [
        function () {
            return {
                restrict: 'E',
                scope: {
                    emailList: '='
                },
                templateUrl: email_list_html_1.default
            };
        }
    ]);
})(angular.module('qualtrics.pr'));
